import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../../../common/loader";
import Breadcrums from "../../../common/breadcrumbs";
import { QuestionDetails } from "../../../services/question.services";
import { questionType } from "../../../../../utils/Constants";
import { formateDateWithMonth } from "../../../../../utils/commonfunction";

const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "de", name: "German" },
  { code: "hu", name: "Hungarian" },
  { code: "es", name: "Spanish" },
];

const QuestionView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Questions"), url: "/admin/cms/question/list/1" },
    { title: "View Question", url: "" },
  ];

  useEffect(() => {
    QuestionDetails(id)
      .then((res) => {
        if (res.success) {
          setQuestion(res.data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <Loader />;
  if (!question) return <div className="text-center py-5">Question not found</div>;

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h4 className="mb-4">Question Details</h4>

              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th width="200">Question Type</th>
                    <td>
                      {questionType.find(qt => qt.value === question.question_type)?.name || "N/A"}
                    </td>
                  </tr>

                  {/* Title in 4 Languages */}
                  <tr>
                    <th>Title</th>
                    <td>
                      {LANGUAGES.map(lang => (
                        <div key={lang.code}>
                          <strong>{lang.name}:</strong> {question.title?.[lang.code] || "Not set"}<br />
                        </div>
                      ))}
                    </td>
                  </tr>

                  {/* Options */}
                  <tr>
                    <th>Options</th>
                    <td>
                      {question.options?.length > 0 ? (
                        <table className="table table-sm table-bordered mt-2">
                          <thead>
                            <tr>
                              <th>Slug</th>
                              {LANGUAGES.map(lang => (
                                <th key={lang.code}>{lang.name}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {question.options.map((opt, i) => (
                              <tr key={i}>
                                <td><strong>{opt.slug}</strong></td>
                                {LANGUAGES.map(lang => (
                                  <td key={lang.code}>
                                    {opt.value?.[lang.code] || "—"}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        "No options"
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th>Status</th>
                    <td>
                      <span className={`badge ${question.status === 1 ? "bg-success" : "bg-secondary"}`}>
                        {question.status === 1 ? "Active" : "Inactive"}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <th>Created</th>
                    <td>{formateDateWithMonth(question.createdAt)}</td>
                  </tr>
                  <tr>
                    <th>Updated</th>
                    <td>{formateDateWithMonth(question.updatedAt)}</td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-4">
                <button
                  className="btn ripple btn-dark"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionView;